import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { useEventAnalytics } from "./AnalyticsProvider";
import isAuthenticatedRoute from "../../isAuthenticatedRoute";

function PageAnalytics() {
  const location = useLocation();
  const { trackCustomEvent } = useEventAnalytics();
  const sessionIdRef = useRef(null);

  useEffect(() => {
    if (!sessionIdRef.current) {
      let sessionId = sessionStorage.getItem("analytics_session_id");

      if (!sessionId) {
        sessionId = `session_${Date.now()}_${Math.random()
          .toString(36)
          .substring(2, 15)}`;
        sessionStorage.setItem("analytics_session_id", sessionId);
      }

      sessionIdRef.current = sessionId;
    }
  }, []);

  // Track page view on route change
  useEffect(() => {
    // Skip if not authenticated route
    if (!isAuthenticatedRoute()) {
      return;
    }
    trackCustomEvent("PAGE_VIEW", {
      pathname: location.pathname,
      search: location.search,
      hash: location.hash,
      fullUrl: window.location.href,
      pageTitle: document.title,
      referrer: document.referrer,
      sessionId: sessionIdRef.current,
    });
  }, [location.pathname, location.search, location.hash, trackCustomEvent]);

  return null;
}

export default PageAnalytics;
